import { useFormikContext } from "formik";
import { ControlcenterMelcoModelsThreadChart, InputField } from "melco-shared-logic";
import { Col, DesignTokens, FormItem, Input, Row } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ThreadVersionSelect } from "../select/ThreadVersionSelect";
import { useUploadThreadAsset } from "../../../hooks/threads/useUploadThreadAsset";

type BasicThreadTabProps = {
    threadId: string;
    refetch: any;
    setIsUploading: (b: boolean) => void;
}

export const BasicThreadTab: React.FC<BasicThreadTabProps> = ({ threadId, refetch, setIsUploading }) => {

    const { values } = useFormikContext<ControlcenterMelcoModelsThreadChart>();
    const { t } = useTranslation();
    const { uploadThreadAsset } = useUploadThreadAsset(threadId)

    const { spacings } = DesignTokens


    return (
        <>
            <Row gutter={[spacings.middle, spacings.small]} >
                <Col xs={24} md={12} xl={12}>
                    <InputField name="file_name" placeholder={t('managethreads.tabs.basic.file_name')} label={t('managethreads.tabs.basic.file_name')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <FormItem label={t('managethreads.tabs.basic.version')}>


                        <ThreadVersionSelect
                            value={values?.version + ""}
                        />
                    </FormItem>
                </Col>
                <Col xs={24} md={24} xl={24}>
                    <FormItem label={t("managethreads.tabs.basic.asset")}>
                        <Input
                            name="file"
                            type="file"

                            onChange={async (e: any) => {
                                try {
                                    //  alert()
                                    setIsUploading(true)
                                    let file = e.currentTarget.files[0];
                                    let response = await uploadThreadAsset(file);

                                    //  console.log(JSON.stringify(response))
                                    await refetch()
                                    setIsUploading(false)
                                }
                                catch (exp: any) {
                                    console.log("Exception occured in File upload ", (exp))
                                    setIsUploading(false)
                                }
                                finally {
                                    setIsUploading(false)
                                }


                            }}
                        />
                    </FormItem>
                </Col>


            </Row>
        </>)
}